var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.styles),attrs:{"src":_vm.computedImage,"alt":_vm.STRINGS.AVATAR},on:{"error":() => (_vm.error = true)}})
}
var staticRenderFns = []

export { render, staticRenderFns }